// extracted by mini-css-extract-plugin
export default {"assetsAmountList":"style_assetsAmountList__WK40v"};